import _lib from '../_lib';
import active from './active/index';
import {SearchPageNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'search';
  let activations = [
    {
      name: 'search',
      test: api.messageIs(SearchPageNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

